import ServiceManager from '../../service/ServiceManager';
import { data } from '../../constants/Constants';
import { getDevice } from './utilApi';
export function ListarProductoFavorito(Centro, CodigoDealer,
    Moneda, Vkorg,
    Poblacion, CorreoElectronicoDealer,
    Linea, Pagenumber) {
    const DispositivoId = getDevice();

    let params = {};
    params.url = "dealer/ListarProductoFavorito";
    params.data = {
        'dto.IBusExacta': 'SI',
        'dto.Centro': Centro,
        'dto.CodigoDealer': CodigoDealer,
        'dto.Moneda': Moneda,
        'dto.Vkorg': Vkorg,
        'dto.Poblacion': Poblacion,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.Pagenumber': Pagenumber,
        'dto.Sistema': data.Sistema,
        'dto.Linea': Linea,
        'dto.Pagesize': data.PageSizeFavorito
    };
    console.log("ListarProductoFavorito===>", params.data);
    return ServiceManager.prototype.Post(params);
}

export function AgregarProductoFavorito(dealer,
    producto,
    linea,
    AplicaFavorito) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/RegistrarProductoFavorito";
    params.data = {
        'dto.CorreoElectronicoDealer': dealer.correoElectronico,
        'dto.CodigoDealer': dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Codigo': producto.codigo,
        'dto.Descripcion': producto.descripcion,
        'dto.Moneda': producto.moneda,
        'dto.Linea': linea.linea,
        'dto.Centro': linea.centro,
        'dto.Vkorg': linea.vkorg,
        'dto.Pantalla': producto.pantalla,
        'dto.Almacen': linea.almacen,
        'dto.Sector': linea.sector,
        'dto.Canal': linea.canal,
        'dto.AplicaFavorito': AplicaFavorito,
        'dto.Sistema': data.Sistema
    };
    console.log("RegistrarProductoFavorito======>",params.data);
    return ServiceManager.prototype.Post(params);
}